module.exports = __webpack_public_path__ + "img/img35.f613dfe2.png";